export default {"src":"/_next/static/media/style.ac32f776.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};